import { createApp } from 'vue';
import { registerSW } from 'virtual:pwa-register';
import VueCookies from 'vue-cookies';
import VueFuether from 'vue-feather';
import dayjs from 'dayjs';
import money from 'v-money3';
import { vMaska } from 'maska';
import VCalendar from 'v-calendar';
import { RouterLink } from 'vue-router';
import './utils/select2Init';
import App from './App.vue';
import AppLayout from './layouts/AppLayout.vue';
import router from './router';
import { FontAwesomeIcon } from './utils';

registerSW({
  onNeedRefresh() {
    if (window.confirm('Nova versão disponível. Atualizar agora?')) {
      window.location.reload();
    }
  },
  onOfflineReady() {
    console.info('[PWA] Aplicação disponível offline.');
  },
});

const app = createApp(App);
app.provide('dayJS', dayjs);

app
  .use(VueCookies)
  .use(router)
  .use(money)
  .use(VCalendar, {})
  .directive('maska', vMaska)
  .component('RouterLink', RouterLink)
  .component(FontAwesomeIcon.name, FontAwesomeIcon)
  .component(AppLayout.name, AppLayout)
  .component(VueFuether.name, VueFuether)
  .mount('#app');
